module.exports = __webpack_public_path__ + "img/xx(1).6cf44ac9.png";